import { z } from 'zod';
import { PaymentsConfigurationFieldName } from './types';

export const paymentsConfigurationFormSchema = z.object({
    [PaymentsConfigurationFieldName.RetentionPolicyDays]: z.number().int().nonnegative(),
    [PaymentsConfigurationFieldName.IsCardSharingEnabled]: z.boolean(),
});

export type PaymentsPolicyConfigurationFormValues = z.infer<typeof paymentsConfigurationFormSchema>;
